
import { FaWhatsapp } from "react-icons/fa";

function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-200 dark:border-white/10 bg-slate-50/90 dark:bg-black/40 backdrop-blur">
      <div className="mx-auto grid max-w-6xl gap-8 px-6 py-10 md:grid-cols-4">
        <div className="space-y-4">
          <p className="font-semibold text-slate-900 dark:text-white text-lg">CodeBoost</p>
          <p className="text-slate-600 dark:text-slate-200/70 text-sm leading-relaxed">
            Inteligência Artificial para negócios inovadores. Transformamos dados em decisões inteligentes.
          </p>
        </div>
        <div>
          <p className="font-semibold text-slate-900 dark:text-white">Navegação</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-200/70">
            <a href="#" className="hover:text-cyan-600 dark:hover:text-cyan-300 transition-colors">Home</a>
            <a href="#servicos" className="hover:text-cyan-600 dark:hover:text-cyan-300 transition-colors">Serviços</a>
            <a href="#beneficios" className="hover:text-cyan-600 dark:hover:text-cyan-300 transition-colors">Benefícios</a>
            <a href="#cases" className="hover:text-cyan-600 dark:hover:text-cyan-300 transition-colors">Cases</a>
            <a href="#contato" className="hover:text-cyan-600 dark:hover:text-cyan-300 transition-colors">Contato</a>
          </div>
        </div>
        <div>
          <p className="font-semibold text-slate-900 dark:text-white">Serviços</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-200/70">
            <span>Machine Learning</span>
            <span>Visão Computacional</span>
            <span>Agentes de IA</span>
            <span>IA Generativa</span>
          </div>
        </div>
        <div>
          <p className="font-semibold text-slate-900 dark:text-white">Contato</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-200/70">
            <span>contato@codeboost.dev.br</span>
            <a
              href="https://wa.me/5561981660749"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-slate-600 dark:text-slate-200/70 hover:text-[#25D366] transition-colors"
              aria-label="Contato via WhatsApp"
            >
              <FaWhatsapp className="h-4 w-4 shrink-0" />
              +55 (61) 98166-0749
            </a>
            <span>Brasília - DF, Brasil</span>
          </div>
        </div>
      </div>

      {/* Partner badges strip */}
      <div className="border-t border-slate-200 dark:border-white/10 px-6 py-3 flex items-center justify-center">
        <a
          href="https://aws.amazon.com/partners/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="AWS Partner Network"
          className="group inline-flex items-center gap-3 rounded-lg border border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-white/5 px-5 py-2.5 opacity-50 hover:opacity-80 transition-opacity duration-200"
        >
          {/* AWS orange arrow + wordmark inline */}
          <svg viewBox="0 0 60 36" className="h-5 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            {/* "AWS" letters */}
            <text x="0" y="22" fontFamily="'Amazon Ember', Arial, sans-serif" fontWeight="700" fontSize="22" fill="#FF9900" letterSpacing="-0.5">AWS</text>
            {/* Smile arrow */}
            <path d="M4 28 Q30 38 56 28" stroke="#FF9900" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
            <path d="M52 25 L57 28 L52 31" stroke="#FF9900" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div className="flex flex-col leading-none">
            <span className="text-[9px] font-medium text-slate-400 dark:text-slate-500 tracking-widest uppercase">Amazon Web Services</span>
            <span className="text-[11px] font-semibold text-slate-700 dark:text-slate-300 tracking-wider uppercase">Partner</span>
          </div>
        </a>
      </div>

      <div className="border-t border-slate-200 dark:border-white/10 px-6 py-4 text-center text-xs text-slate-500 dark:text-slate-200/60">
        © 2025 CodeBoost. Todos os direitos reservados.
      </div>
    </footer>
  );
}

export default Footer;
